import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'table-btn-row',
  templateUrl: './table-btn-row.component.html',
  styleUrls: ['./table-btn-row.component.scss']
})
export class TableBtnRowComponent implements OnInit {
  @Input() isDeleteBtn: boolean;
  @Input() isEditBtn: boolean;
  @Input() isInfoBtn: boolean;
  @Input() isArrangeClassBtn: boolean;
  @Input() isPasswordRecoveryBtn: boolean;
  @Input() iconEdit: string;
  @Input() iconDelete: string;
  @Input() titleEdit: string;
  @Output() delete = new EventEmitter();
  @Output() info = new EventEmitter();
  @Output() edit = new EventEmitter();
  @Output() arrangeClass = new EventEmitter();
  @Output() passwordRecovery = new EventEmitter();
  constructor() { }
  icon_edit: string = 'edit';
  icon_delete: string = 'delete';
  title_edit: string = 'Sửa';
  ngOnInit() {
    if (this.iconEdit) {
      this.icon_edit = this.iconEdit;
    }
    if (this.iconDelete) {
      this.icon_delete = this.iconDelete;
    }
    if (this.titleEdit) {
      this.title_edit = this.titleEdit;
    }
  }
  editEvent(event) {
    this.edit.emit(event);
  }
  deleteEvent(event) {
    this.delete.emit(event);
  }
  infoEvent(event) {
    this.info.emit(event);
  }
  arrangeClassEvent(event) {
    this.arrangeClass.emit(event);
  }
  passwordRecoveryEvent(event) {
    this.passwordRecovery.emit(event);
  }
}
